import React from 'react';
import PropTypes from 'prop-types';

const ArrowTabs = ({ tabs, onTabChange, className = '' }) => {
  return (
    <div className={`flex items-stretch ${className}`} style={{ height: '60px' }}>
      {tabs.map((tab, index) => {
        const isLast = index === tabs.length - 1;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange?.(tab.id)}
            data-tutorial-id={tab.tutorialId}
            className="relative outline-none transition-opacity hover:opacity-90"
            style={{
              flex: 1,
              marginRight: isLast ? '0' : '-12px',
              zIndex: tab.isActive ? 10 : 1,
            }}
          >
            {/* Arrow tab border (outer layer) */}
            <div
              className={`absolute inset-0 transition-colors duration-200 ${
                tab.isActive
                  ? 'bg-succession-primary'
                  : 'bg-gray-300'
              }`}
              style={{
                clipPath: isLast
                  ? 'polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%, 12px 50%)'
                  : index === 0
                  ? 'polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%)'
                  : 'polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)',
              }}
            />
            
            {/* Arrow tab background (inner layer) */}
            <div
              className={`absolute transition-colors duration-200 ${
                tab.isActive
                  ? 'bg-succession-primary'
                  : 'bg-white hover:bg-gray-50'
              }`}
              style={{
                top: '2px',
                left: index === 0 ? '2px' : '0',
                right: '2px',
                bottom: '2px',
                clipPath: isLast
                  ? 'polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%, 12px 50%)'
                  : index === 0
                  ? 'polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%)'
                  : 'polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)',
              }}
            />

            {/* Content */}
            <div className="relative z-10 flex flex-col items-center justify-center h-full px-4">
              <div
                className={`text-xs font-semibold text-center uppercase tracking-wide transition-colors duration-200 ${
                  tab.isActive ? 'text-white' : 'text-gray-700'
                }`}
              >
                {tab.label}
                {tab.count !== undefined && tab.count > 0 && (
                  <span className="ml-2 inline-flex items-center justify-center h-5 min-w-[20px] rounded-full px-1.5 text-[11px] font-bold bg-succession-secondary text-white">
                    {tab.count}
                  </span>
                )}
              </div>
              {tab.subLabel && (
                <div
                  className={`text-xs font-medium capitalize mt-0.5 transition-colors duration-200 ${
                    tab.isActive ? 'text-white opacity-90' : 'text-gray-500'
                  }`}
                >
                  {tab.subLabel}
                </div>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

ArrowTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
      subLabel: PropTypes.string,
      tutorialId: PropTypes.string,
      isActive: PropTypes.bool,
    })
  ).isRequired,
  onTabChange: PropTypes.func,
  className: PropTypes.string,
};

export default ArrowTabs;